import { Button } from "@material-ui/core";
import React from "react";
import {
  Datagrid,
  Filter,
  List,
  TextField,
  SearchInput,
  FunctionField,
  ListProps,
  SelectInput,
} from "react-admin";
import { Helmet } from "react-helmet";
import VisibilityIcon from "@material-ui/icons/Visibility";
import StatusField from "components/StatusField";
import { statusList } from "./const";

const AssistantFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
    <SelectInput label="Status" source="Status" choices={statusList} alwaysOn />
  </Filter>
);

const AssistantList = (props: ListProps) => {
  const AssistantShowButton = (record: IDriver) => {
    return (
      <Button href={`/#/busAssistants/${record.id}/show`}>
        <VisibilityIcon />
      </Button>
    );
  };

  return (
    <>
      <Helmet>
        <title>Bus Assistants</title>
      </Helmet>
      <List
        {...props}
        exporter={false}
        hasCreate={false}
        filters={<AssistantFilter />}
        bulkActionButtons={false}
      >
        <Datagrid rowClick="show">
          <TextField source="id" emptyText="-" />
          <TextField source="fullName" emptyText="-" />
          <TextField source="contactNumber" emptyText="-" />
          <StatusField source="status" />
          <FunctionField
            label="Actions"
            render={(props: any) => (
              <>
                <AssistantShowButton {...props} />
              </>
            )}
          />
        </Datagrid>
      </List>
    </>
  );
};

export default AssistantList;
